import Modal from '@mui/material/Modal';
import React from 'react';
import Button from '../core/Button';
import styles from './OfferFormModal.module.scss';
import { useForm } from 'react-hook-form';
import FormElement from '../core/FormElement';

export interface Props {
  open: boolean;
  offer: any;
  property: any;
  onClose: () => void;
  onSubmit: (price: number) => void;
}

export default function OfferFormModal(props: Props) {
  if (!props.open) {
    return null;
  }

  const hasOffer = Boolean(props.offer);
  const { handleSubmit, control } = useForm({
    defaultValues: {
      // TODO: tengo que verificar que la oferta no esté rechazada/cancelada por un bug
      // la oferta deberia eliminarse cuando se reinicia el proceso
      price:
        (props.offer?.status !== 'rechazada' &&
          props.offer?.status !== 'cancelada' &&
          props.offer?.offer) ||
        props.property?.prices?.property ||
        '',
    },
  });

  return (
    <Modal open className={styles.container} onClose={props.onClose}>
      <div className={styles.content}>
        <h1>{hasOffer ? 'Editar oferta' : 'Crear oferta'}</h1>
        <p>Ingresa el nuevo precio de venta</p>

        <form onSubmit={handleSubmit((data) => props.onSubmit(data.price))}>
          <FormElement
            divStyle={{ display: 'inline-block' }}
            name="price"
            label="Precio"
            control={control}
            rules={{ required: true }}
            elementType="price"
          />

          <small>El comprador será notificado</small>
          <Button label="ACEPTAR" type="submit" />
        </form>
      </div>
    </Modal>
  );
}
